
import { Component, Vue } from 'vue-property-decorator';
import ProjectSidebar from '@/components/default-layout/ProjectSidebar.vue';
import ChainSidebar from '@/components/default-layout/ChainSidebar.vue';

@Component({
  name: 'default-sidebar',
  components: { ProjectSidebar, ChainSidebar },
})
export default class DefaultSidebar extends Vue {
  get sidebar() {
    const name = this.$route.name || '';
    if (name.startsWith('project')) {
      return 'project-sidebar';
    }
    if (name.startsWith('chain')) {
      return 'chain-sidebar';
    }
    return null;
  }
}
